import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsSectionLink from '../APIDocsSectionLink';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsCreateCommentBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Create comment</div>
          <div className="text">Creates a new comment.</div>
          <div className="text">
            {'You may also want to use the '}
            <APIDocsSectionLink
              sectionID="create_or_update_user"
              onScrollToSection={this.props.onScrollToSection}
            />
            {" endpoint to make sure the comment author's account exists (and fetch their id)."}
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The unique identifier of the comment's author.",
                heading: 'authorID',
                subheading: 'string',
              },
              {
                description: "The unique identifier of the comment's post.",
                heading: 'postID',
                subheading: 'string',
              },
              {
                description: 'The comment value.',
                heading: 'value',
                subheading: 'string',
              },
              {
                description: "An array of the URLs of comment's images.",
                heading: 'imageURLs',
                subheading: 'array (optional)',
              },
              {
                description:
                  'Whether this comment is only available for internal usage. Default is false. This can only be set to true if the author is a member of the company.',
                heading: 'internal',
                subheading: 'boolean (optional)',
              },
              {
                description:
                  "The unique identifier of the comment's parent, if this comment is a reply.",
                heading: 'parentID',
                subheading: 'string (optional)',
              },
              {
                description:
                  'Whether this comment should be allowed to trigger email notifications. Default is false.',
                heading: 'shouldNotifyVoters',
                subheading: 'boolean (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Upon success, returns an object with a single key: id.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/comments/create</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/comments/create"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d authorID=553c3ef8b8cdcd1501ba1238 \\
    -d postID=553c3ef8b8cdcd1501ba1240 \\
    -d value="This is the comment's value"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba2200",
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
